import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectIsDepartmentStateLoaded } from '@shared/store/departments/departments.selectors';
import { combineLatest, filter, map, of, switchMap, take } from 'rxjs';
import { AuthorizationsService } from '../services/authorizations.service';

export const isUserDepartmentAdminGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authorizationService = inject(AuthorizationsService);
  const store = inject(Store);
  const router = inject(Router);

  const clientCode = route.params.clientCode;

  if (!clientCode) {
    console.error('Client code is missing');
    router.navigate(['/home']);
    return of(false);
  }

  // Wait for this client's departments to load before reading membership, so a
  // slow load doesn't misread the user as non-admin (the load always resolves,
  // even on failure).
  return store.select(selectIsDepartmentStateLoaded(clientCode)).pipe(
    filter((isLoaded) => isLoaded),
    take(1),
    switchMap(() =>
      combineLatest([
        authorizationService.isDepartmentAdminParams$(clientCode, +route.params.departmentId),
        authorizationService.isClientSupport$(clientCode),
      ]),
    ),
    map(([isDepartmentAdmin, hasSupportAccess]) => {
      if (!isDepartmentAdmin && !hasSupportAccess) {
        router.navigate(['/client', clientCode]);
        return false;
      }
      return true;
    }),
  );
};
